import { useState } from "react";
import { RecipeResult } from "../../api/recipeResults";
import { Recipe } from "../../api/recipeSimulator";
import { RecipeVariantCol } from "../../config/constants";
import FilterVarientTableModal from "./FilterVarientTableModal";
import RecipeSimulatorDetailsCard from "./RecipeSimulatorDetailsCard";
import RecipeVariationTable from "./RecipeVariationTable";
import { useRecipeImpactChart } from "./recipeResultDetails/hooks/useRecipeImpactChart";
import { useRecipeVariantData } from "./recipeResultDetails/hooks/useRecipeVariantData";
import { SelectedVariant } from "./recipeResultDetails/recipeImpactChart.types";

interface RecipeResultDetailsViewProps {
  recipeResults: RecipeResult | undefined;
  originalRecipeData: Recipe | null;
  productSize: number;
  setProductSize: (size: number) => void;
  selectedVariants: SelectedVariant[];
  setSelectedVariants: (variants: SelectedVariant[]) => void;
  readOnly?: boolean;
}

const RecipeResultDetailsView = ({
  recipeResults,
  originalRecipeData,
  productSize,
  setProductSize,
  selectedVariants,
  setSelectedVariants,
  readOnly = false
}: RecipeResultDetailsViewProps) => {
  const [visibleFilterColumnModal, setVisibleFilterColumnModal] = useState<boolean>(false);
  const [visibleCols, setVisibleCols] = useState(
    RecipeVariantCol.filter(col => col.name !== "").map(col => col.name)
  );

  const originalRecipeImpact =
    recipeResults?.originalRecipetotalImpacts?.climateChange?.measure || 0;

  const variantData = useRecipeVariantData(recipeResults, originalRecipeData);

  const chartRef = useRecipeImpactChart({ recipeResults, originalRecipeData, selectedVariants });

  return (
    <>
      <div className="tw-mb-8 tw-grid tw-grid-cols-1 tw-items-start tw-gap-4 lg:tw-grid-cols-4 lg:tw-gap-6">
        <div className="tw-pl-1">
          <RecipeSimulatorDetailsCard
            currentImpactChange={originalRecipeImpact}
            setVisibleFilterColumnModal={setVisibleFilterColumnModal}
            productSize={productSize}
            setProductSize={setProductSize}
            readOnly={readOnly}
          />
        </div>
        <div className="tw-h-full tw-mt-[5px] lg:tw-col-span-3">
          <div
            ref={chartRef}
            className="-tw-mt-1.5 tw-h-full tw-w-full tw-rounded-[5px] tw-border tw-border-primary tw-bg-white"
          />
        </div>
      </div>
      <RecipeVariationTable
        originalRecipeImpact={originalRecipeImpact}
        variantData={variantData}
        visibleCols={visibleCols}
        selectedVariants={selectedVariants}
        setSelectedVariants={setSelectedVariants}
        productSize={productSize}
        setProductSize={setProductSize}
        recipeId={recipeResults?.recipeId || ""}
        currentImpactChange={originalRecipeImpact}
        readOnly={readOnly}
      />
      {visibleFilterColumnModal ? (
        <FilterVarientTableModal
          visibleModal={visibleFilterColumnModal}
          setVisibleModal={() => {
            setVisibleFilterColumnModal(false);
          }}
          visibleCols={visibleCols}
          setVisibleCols={setVisibleCols}
        />
      ) : null}
    </>
  );
};

export default RecipeResultDetailsView;
